var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 186,
    viewBox: "0 0 250 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.45 178.511C205.483 161.28 218.907 135.109 218.907 105.798C218.907 53.9096 176.843 11.8457 124.955 11.8457C73.0652 11.8457 31 53.9096 31 105.798C31 135.109 44.4242 161.28 65.4574 178.511C83.2534 178.215 103.491 178.047 124.955 178.047C146.419 178.047 166.654 178.215 184.45 178.511Z",
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0651 186.001H206.653C208.379 186.001 209.778 184.603 209.778 182.877C209.778 181.151 208.379 179.75 206.653 179.75H52.0651C50.3381 179.75 48.9395 181.151 48.9395 182.877C48.9395 184.603 50.3381 186.001 52.0651 186.001Z",
    fill: "#C9C1AE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0418915 139.445V136.869C0.00151349 137.81 0.00712154 138.676 0.0418915 139.445Z",
    fill: "#C9C1AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08442 127.363C4.39905 121.534 8.54863 116.44 14.058 113.414C25.7863 106.971 40.1549 109.851 53.4082 111.699C111.658 119.823 171.128 104.089 224.115 78.5655C232.249 74.647 240.607 70.2122 245.737 62.7815C248.603 58.6293 250.075 53.2736 249.649 48.2985V30.4971C249.546 32.1002 249.267 33.9337 248.646 35.904C248.111 37.5976 247.441 39.0299 246.791 40.1908C246.463 40.7748 246.114 41.3434 245.737 41.8893C240.607 49.3199 232.249 53.7548 224.115 57.6733C171.128 83.197 111.658 98.9306 53.4082 90.8072C40.1549 88.9588 25.7863 86.0792 14.058 92.5221C5.73264 97.0957 0.503698 106.384 0.0423423 115.81V115.745C-0.00738244 116.601 -0.0204679 117.597 0.0423423 118.699V118.469M0.0419672 118.699V136.87C0.0909441 135.74 0.208339 134.501 0.439391 133.171C0.842797 130.846 1.47464 128.889 2.08442 127.363",
    fill: "#C9C1AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.648 27.3809V30.4967C249.724 29.3168 249.708 28.2583 249.648 27.3809Z",
    fill: "#C9C1AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8867 95.665C14.0191 102.376 14.151 103.524 14.2834 110.235",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3339 91.4131C36.0774 97.3034 35.8209 101.571 35.5645 107.461",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6373 94.3594C57.5083 99.9783 57.379 105.597 57.25 111.216",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3945 96.6465C92.5654 101.449 92.7362 106.252 92.9071 111.054",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.18 94.6865C112.157 99.8691 112.134 105.052 112.111 110.235",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.318 87.4834C146.684 92.94 147.049 98.3967 147.415 103.854",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.602 83.5576C164.849 88.9574 165.097 94.3568 165.345 99.7567",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.104 59.8262C226.21 64.8454 226.318 69.8646 226.425 74.8838",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.857 52.7793C239.293 57.5256 239.729 62.2722 240.165 67.0185",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65323 147.204C6.32249 159.433 20.6679 167.074 33.4221 164.127V143.235C21.0376 146.097 7.15473 138.974 2.08542 127.362C-0.420254 133.673 -0.773935 140.847 1.65323 147.204Z",
    fill: "#F5EAD2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244.845 17.1109C240.305 13.0047 233.495 12.2439 227.536 13.6459C221.578 15.0476 216.253 18.3129 211.045 21.5286V42.4204C216.253 39.2044 221.578 35.9394 227.536 34.5374C233.495 33.1358 240.305 33.8962 244.845 38.0024C245.584 38.6709 246.228 39.4067 246.792 40.1907C250.923 32.8258 251.049 22.7227 244.845 17.1109Z",
    fill: "#F5EAD2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1955 164.951C27.1933 165.231 27.2078 165.549 27.4217 165.729C27.6408 165.913 27.9657 165.867 28.2465 165.81C29.8014 165.494 31.3567 165.178 32.9116 164.863C33.1853 164.807 33.4769 164.742 33.6706 164.541C33.9184 164.283 33.9311 163.886 33.9289 163.529C33.8852 156.489 33.8418 149.449 33.798 142.41C33.7969 142.262 29.18 143.233 28.7575 143.429C27.511 144.004 27.8797 146.048 27.809 147.214C27.5802 150.979 27.4142 154.748 27.3107 158.519C27.2523 160.662 27.2138 162.807 27.1955 164.951Z",
    fill: "#1B1836"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M210.269 42.6946C210.258 43.2475 210.32 43.9239 210.822 44.156C211.207 44.3344 211.655 44.1448 212.034 43.9515C213.421 43.2427 214.767 42.4516 216.061 41.5842C216.357 33.801 216.214 26.0009 215.635 18.2334C215.637 18.2555 211.044 20.1274 210.697 20.9466C210.325 21.824 210.644 23.6074 210.625 24.5727C210.601 25.7732 210.578 26.9737 210.554 28.1739C210.459 33.014 210.364 37.8541 210.269 42.6946Z",
    fill: "#1B1836"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M223.994 19.0762C223.851 23.9212 223.896 28.7714 224.128 33.613",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.027 19.498C239.786 24.1953 239.692 28.9001 239.744 33.603",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77829 137.54C5.65865 141.423 5.75473 145.312 6.06617 149.184",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2659 145.016C18.1837 149.609 18.1018 154.202 18.0195 158.795",
    stroke: "#650D1B",
    strokeWidth: 1.1465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.826 26.8887C137.048 20.2269 142.921 3.63893 142.921 3.63893L137.952 0C137.952 0 137.121 26.5073 125.32 26.6859C113.518 26.5066 112.687 0 112.687 0L107.718 3.63893C107.718 3.63893 113.592 20.2269 95.813 26.8887C93.7447 49.9378 108.161 59.1386 106.069 77.8835H125.319H144.569C142.478 59.1386 156.894 49.9371 154.826 26.8887Z",
    fill: "#650D1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.567 77.8838H125.317H106.066C89.2278 89.2124 85.7966 137.427 56.3633 163.971C56.3633 163.971 77.4908 174.986 125.317 174.986C173.143 174.986 194.27 163.971 194.27 163.971C164.837 137.427 161.405 89.2124 144.567 77.8838Z",
    fill: "#650D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.519 71.0137H106.113C106.327 73.1775 106.338 75.4493 106.066 77.8838H125.317H144.567C144.295 75.4486 144.306 73.1775 144.519 71.0137Z",
    fill: "#F5EAD2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.257 77.8838H124.271H115.284C105.121 90.8377 105.933 157.019 92.9316 174.986C92.9316 174.986 104.372 176.972 124.271 176.972C144.169 176.972 155.609 174.986 155.609 174.986C142.608 157.019 143.42 90.8377 133.257 77.8838Z",
    fill: "#FFFFF6",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeAdded);
export default __webpack_public_path__ + "static/media/sizeAdded.c359d29a497fd194e081952343ef706c.svg";
export { ForwardRef as ReactComponent };